import { Application } from "@hotwired/stimulus"

import "@/styles/online_accounts_index.scss"

import DisclosureItemController from "../../controllers/disclosure_item_controller"

const setupStimulus = (): void => {
  const application = Application.start()

  application.register("disclosure-item", DisclosureItemController)
}

setupStimulus()
